module.exports = __webpack_public_path__ + "static/media/i.3850fb5d.svg";